import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import { CommonErrorBoundary } from "../../ErrorBoundary";
const ConfigurationTreeSwitch = lazy(() => import("./ConfigurationTreeSwitch"));
const ComponentProvider = lazy(() => import("./ConfigurationTreeProvider"));
/**
 * Shows a navigation tree of the configuration.
 *
 * Can be placed directly in the layout or directly in `<ConfigurationRenderer />` to control navigation.
 * @param props
 * @returns
 */
export function ConfigurationTree(props) {
    const { components } = props, restProps = __rest(props, ["components"]);
    return (_jsx(CommonErrorBoundary, { children: _jsx(Suspense, { children: _jsx(ComponentProvider, { components: components, children: _jsx(ConfigurationTreeSwitch, Object.assign({}, restProps)) }) }) }));
}
//# sourceMappingURL=ConfigurationTree.js.map